import React, { useEffect, useRef, useState } from "react";
import avatarPerfil from "../../../assets/avatar-de-perfil.png";
import { adicionarCadastroPessoa } from "../../../api/requisicoes/pessoas";
import { listarPerfil } from "../../../api/requisicoes/variaveis";
import Loading from "../../../components/Loading";
import { useAlert } from "../../../context/AlertContext";
import "./style.css";

const CadastroPessoaMobile = () => {
    const [nome, setNome] = useState("");
    const [documento, setDocumento] = useState("");
    const [outroDocumento, setOutroDocumento] = useState(false);
    const [perfilId, setPerfilId] = useState("");
    const [perfis, setPerfis] = useState([]);
    const [carregandoPerfis, setCarregandoPerfis] = useState(true);
    const [erroPerfis, setErroPerfis] = useState("");
    const [foto, setFoto] = useState(null);
    const [urlPrevia, setUrlPrevia] = useState(null);
    const [carregando, setCarregando] = useState(false);

    const entradaCameraRef = useRef(null);
    const entradaGaleriaRef = useRef(null);
    const { showAlert } = useAlert();

    useEffect(() => {
        let componenteAtivo = true;

        const carregarPerfis = async () => {
            try {
                const dados = await listarPerfil();

                if (componenteAtivo) {
                    setPerfis(
                        [...dados].sort((perfilA, perfilB) =>
                            perfilA.profileType.localeCompare(
                                perfilB.profileType
                            )
                        )
                    );
                }
            } catch (erro) {
                console.error("Erro ao buscar perfis:", erro);

                if (componenteAtivo) {
                    setErroPerfis("Não foi possível carregar os perfis.");
                }
            } finally {
                if (componenteAtivo) {
                    setCarregandoPerfis(false);
                }
            }
        };

        carregarPerfis();

        return () => {
            componenteAtivo = false;
        };
    }, []);

    useEffect(() => {
        return () => {
            if (urlPrevia) {
                URL.revokeObjectURL(urlPrevia);
            }
        };
    }, [urlPrevia]);

    const limparString = (valor) =>
        valor
            .replace(/[.,#!$%^&*;:{}=_`~()-]/g, "")
            .split("/")
            .join("")
            .trim();

    const formatarCpf = (valor) => {
        let cpfFormatado = valor.replace(/\D/g, "").slice(0, 11);

        if (cpfFormatado.length > 9) {
            cpfFormatado = cpfFormatado.replace(
                /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                "$1.$2.$3-$4"
            );
        } else if (cpfFormatado.length > 6) {
            cpfFormatado = cpfFormatado.replace(
                /^(\d{3})(\d{3})(\d{0,3})/,
                "$1.$2.$3"
            );
        } else if (cpfFormatado.length > 3) {
            cpfFormatado = cpfFormatado.replace(
                /^(\d{3})(\d{0,3})/,
                "$1.$2"
            );
        }

        return cpfFormatado;
    };

    const alterarDocumento = (evento) => {
        const valor = outroDocumento
            ? evento.target.value
            : formatarCpf(evento.target.value);
        setDocumento(valor);
    };

    const selecionarFoto = (evento) => {
        const arquivo = evento.target.files?.[0];

        if (!arquivo) {
            return;
        }

        setFoto(arquivo);
        setUrlPrevia(URL.createObjectURL(arquivo));
    };

    const abrirSeletor = (referencia) => {
        if (referencia.current) {
            referencia.current.value = "";
            referencia.current.click();
        }
    };

    const limparFormulario = () => {
        setNome("");
        setDocumento("");
        setOutroDocumento(false);
        setPerfilId("");
        setFoto(null);
        setUrlPrevia(null);
    };

    const cadastrarPessoa = async (evento) => {
        evento.preventDefault();

        if (!foto) {
            showAlert("É necessário adicionar uma foto!", "erro");
            return;
        }

        if (!outroDocumento && limparString(documento).length !== 11) {
            showAlert("CPF deve possuir 11 dígitos!", "erro");
            return;
        }

        const novaPessoa = {
            cpf: limparString(documento),
            nomeCompleto: limparString(nome),
            perfilId,
            foto,
        };

        try {
            setCarregando(true);
            await adicionarCadastroPessoa(novaPessoa);
            showAlert("Pessoa cadastrada com sucesso!", "sucesso");
            limparFormulario();
        } catch (erro) {
            if (erro.response) {
                showAlert(`Erro! ${erro.response.data.error}.`, "erro");
            } else {
                showAlert(
                    "Erro desconhecido, contate o administrador do sistema!",
                    "erro"
                );
            }
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div className="cadastroPessoaMobile-tela">
            {carregando && <Loading />}

            <header className="cadastroPessoaMobile-header">
                <h1>Cadastro de Pessoa</h1>
            </header>

            <form
                className="cadastroPessoaMobile-formulario"
                onSubmit={cadastrarPessoa}
            >
                <section className="cadastroPessoaMobile-foto">
                    <div className="cadastroPessoaMobile-fotoMoldura">
                        <img
                            src={urlPrevia || avatarPerfil}
                            alt="Pré-visualização da pessoa"
                        />
                    </div>

                    <div className="cadastroPessoaMobile-fotoAcoes">
                        <button
                            type="button"
                            onClick={() => abrirSeletor(entradaCameraRef)}
                        >
                            <i className="fas fa-camera" aria-hidden="true"></i>
                            Tirar Foto
                        </button>
                        <button
                            type="button"
                            onClick={() => abrirSeletor(entradaGaleriaRef)}
                        >
                            <i className="fas fa-image" aria-hidden="true"></i>
                            Galeria
                        </button>
                    </div>

                    <input
                        ref={entradaCameraRef}
                        className="cadastroPessoaMobile-arquivo"
                        type="file"
                        accept="image/*"
                        capture="environment"
                        onChange={selecionarFoto}
                    />
                    <input
                        ref={entradaGaleriaRef}
                        className="cadastroPessoaMobile-arquivo"
                        type="file"
                        accept="image/*"
                        onChange={selecionarFoto}
                    />
                </section>

                <div className="cadastroPessoaMobile-campo">
                    <label htmlFor="cadastroPessoaMobile-nome">Nome</label>
                    <input
                        id="cadastroPessoaMobile-nome"
                        type="text"
                        value={nome}
                        onChange={(evento) => setNome(evento.target.value)}
                        onBlur={(evento) =>
                            setNome(evento.target.value.toUpperCase())
                        }
                        autoComplete="name"
                        required
                    />
                </div>

                <div className="cadastroPessoaMobile-documentoHeader">
                    <label htmlFor="cadastroPessoaMobile-documento">
                        {outroDocumento
                            ? "Documento"
                            : "CPF (somente números)"}
                    </label>
                    <label className="cadastroPessoaMobile-checkbox">
                        <input
                            type="checkbox"
                            checked={outroDocumento}
                            onChange={() => {
                                setOutroDocumento((valorAtual) => !valorAtual);
                                setDocumento("");
                            }}
                        />
                        Outro Documento
                    </label>
                </div>
                <div className="cadastroPessoaMobile-campo">
                    <input
                        id="cadastroPessoaMobile-documento"
                        type="text"
                        inputMode={outroDocumento ? "text" : "numeric"}
                        value={documento}
                        onChange={alterarDocumento}
                        placeholder={
                            outroDocumento
                                ? "Digite o documento"
                                : "XXX.XXX.XXX-XX"
                        }
                        required
                    />
                </div>

                <div className="cadastroPessoaMobile-campo">
                    <label htmlFor="cadastroPessoaMobile-perfil">Perfil</label>
                    <select
                        id="cadastroPessoaMobile-perfil"
                        value={perfilId}
                        onChange={(evento) => setPerfilId(evento.target.value)}
                        disabled={carregandoPerfis}
                        required
                    >
                        <option value="">
                            {carregandoPerfis
                                ? "Carregando perfis..."
                                : "Selecione um perfil"}
                        </option>
                        {perfis.map((perfil) => (
                            <option key={perfil.id} value={perfil.id}>
                                {perfil.profileType}
                            </option>
                        ))}
                    </select>
                    {erroPerfis && (
                        <span className="cadastroPessoaMobile-erro">
                            {erroPerfis}
                        </span>
                    )}
                </div>

                <button
                    className="cadastroPessoaMobile-botaoCadastrar"
                    type="submit"
                    disabled={carregando || carregandoPerfis}
                >
                    Cadastrar
                </button>
            </form>
        </div>
    );
};

export default CadastroPessoaMobile;
